import { Event } from '../event';
import EventCard from './EventCard';

export default function DayRow({ events, day, onDelete }: { events: Event[], day: string, onDelete: () => void }) {

    return (
        <div className="events-day" style={{ margin: "20px"}}>
            <h2>{day}</h2>
            <div className="events" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {events.map((event) => (
                    <EventCard key={event.id} event={event} onDelete={onDelete} />
                ))}
            </div>
        </div>
    );
}
